var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFolderMove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M464,128H272l-64-64H48C21.5,64,0,85.5,0,112v288c0,26.5,21.5,48,48,48h416c26.5,0,48-21.5,48-48V176 C512,149.5,490.5,128,464,128z M363.9,293.3l-34.3,34.4c-6.5,6.5-17.8,1.9-17.8-7.4v-22.2h-43.7v43.7h22.2c9.3,0,13.9,11.2,7.4,17.8 L263.4,394c-4.1,4.1-10.7,4.1-14.7,0l-34.3-34.3c-6.5-6.5-1.9-17.8,7.4-17.8h22.2l0-43.7h-43.7v22.2c0,9.3-11.2,13.9-17.8,7.4 l-34.3-34.4c-4.1-4.1-4.1-10.7,0-14.7l34.3-34.3c6.5-6.5,17.8-1.9,17.8,7.4v22.2h43.7v-43.7h-22.2c-9.3,0-13.9-11.2-7.4-17.8 l34.3-34.3c4.1-4.1,10.7-4.1,14.7,0l34.3,34.3c6.5,6.5,1.9,17.8-7.4,17.8h-22.2v43.7h43.7v-22.2c0-9.3,11.2-13.9,17.8-7.4l34.3,34.3 C368,282.7,368,289.3,363.9,293.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFolderMove);
export default __webpack_public_path__ + "static/media/icon-folder-move.3b26e7dd7eefc88f4752180d22f107bf.svg";
export { ForwardRef as ReactComponent };